import React from 'react';
import { Fortellis } from 'fortellis';
import '../index.scss';

const FortellisUser = ({ auth, entity }) => {
  const loggedInUser = {
    user: {
      userGuid: auth?.sub || '',
      loginId: auth?.userData?.email || '',
      firstName: auth?.userData?.name?.split(' ')[0] || '',
      helloMessage:
        "I'm AIVA. I can answer questions you have about Fortellis.",
      orgId: auth?.entityId || '',
      userRole: ['Developer'],
      orgName: entity?.name || ''
    },
    stores: []
  };
  return (
    <div className="chatbot-container">
      <Fortellis
        user={loggedInUser}
        aivaVoice={true}
        token={auth?.accessToken}
        theme="light"
        isDemo={false}
      />
    </div>
  );
};

export default FortellisUser;
